<template>
  <div
    class="hit-table-row bg-table hover:bg-table-hover border-t"
    :class="{
      'bg-table-depending-level': item?.selected,
      'bg-level-1': expandLevel !== null && expandLevel % 3 === 1,
      'bg-level-2': expandLevel !== null && expandLevel % 3 === 2,
      'bg-level-3': expandLevel !== null && expandLevel % 3 === 0,
    }"
  >
    <slot />
  </div>
  <!-- Expandable details row -->
  <div
    v-if="expanded"
    class="hit-table-details bg-table pl-4"
  >
    <slot
      name="expanded-row"
      :item="item"
    />
  </div>
</template>

<script>
export default {
  name: 'HitTableRow',
  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: null,
    },
    expandLevel: {
      type: Number,
      default: null,
    },
  },

  emits: ['click', 'mousedown'],
};
</script>

<style lang="scss">
.hit-table-row {
  @apply cursor-pointer grid px-2 hover:shadow-sm h-auto min-h-11;
  padding-right: 0.375rem;
  padding-left: 0.375rem;
  background-color: white;
  grid-template-columns: var(--grid-template-columns);
  gap: 8px;
  border-color: rgba(0, 0, 0, 0);
}

.bg-level-1 {
  background-color: var(--color-table-level-1) !important;
}

.bg-level-2 {
  background-color: var(--color-table-level-2) !important;
}

.bg-level-3 {
  background-color: var(--color-table-level-3) !important;
}

.bg-level-1:hover {
  background-color: var(--color-table-level-1-hover) !important;
}

.bg-level-2:hover {
  background-color: var(--color-table-level-2-hover) !important;
}

.bg-level-3:hover {
  background-color: var(--color-table-level-3-hover) !important;
}

.inward-border {
  box-shadow: inset 0px 0px 0px 2px #0a0 !important;
}
.inward-border-transparent {
  box-shadow: inset 0px 0px 0px 2px transparent !important;
  transition: box-shadow 0.5s ease-out !important;
}
.drag-border-top {
  border-color: #0a0 !important;
}

.hit-table-details {
  @apply h-auto min-h-11;
  grid-column: 1 / -1;
}
</style>
